module.exports = __webpack_public_path__ + "img/samoa.89588991.svg";